import { authedJson } from '../http';

export interface WatchlistItem {
  id: number;
  user_id: number;
  symbol: string;
  instrument_id: number | null;
  instrument_name: string | null;
  instrument_name_sch: string | null;
  instrument_name_tch: string | null;
  instrument_exchange: string | null;
  instrument_currency: string | null;
  instrument_sector: string | null;
  instrument_industry: string | null;
  has_thesis: boolean;
  added_at: string;
}

export interface WatchlistCaptureResponse {
  item: WatchlistItem;
  current_price: number | null;
}

export function getWatchlist(): Promise<WatchlistItem[]> {
  return authedJson('GET', '/api/v1/watchlist');
}

export function captureWatchlist(symbol: string): Promise<WatchlistCaptureResponse> {
  // /capture returns { item, current_price }, not a bare item.
  return authedJson('POST', '/api/v1/watchlist/capture', { symbol });
}

export function deleteWatchlist(itemId: number): Promise<void> {
  return authedJson('DELETE', `/api/v1/watchlist/${itemId}`);
}
